// ContentDashboardStatus enum matching backend enum
// Backend sends the Description attribute values from the C# enum
// Note: We only handle Draft and Active in the UI, Inactive is managed elsewhere
export enum ContentDashboardStatus {
  Draft = "DRAFT",
  Active = "ACTIVE",
}

export const ContentDashboardStatusDisplayNames: Record<
  ContentDashboardStatus,
  string
> = {
  [ContentDashboardStatus.Draft]: "Draft",
  [ContentDashboardStatus.Active]: "Active",
};
